import gql from "graphql-tag";

export const GET_PUBLISHED_ICON_DATA = gql`
    query getPublishedIconData($limit: Int, $username: String!) {
        icons: browseIconsByCreator(limit: $limit, username: $username) {
            items {
                id
                thumbnails {
                    thumbnail200
                }
                title
                url
            }
            totalCount
        }
    }
`;

export const GET_COLLECTION_DATA = gql`
    query getCollectionData(
        $username: String!
        $limit: Int
        $offset: Int = 0
        $iconsPerCollectionLimit: Int = 6
    ) {
        collections: browseCollectionsByCreator(
            username: $username
            limit: $limit
            offset: $offset
        ) {
            items {
                id
                name
                slug
                url
                icons(limit: $iconsPerCollectionLimit) {
                    items {
                        id
                        title
                        thumbnails {
                            thumbnail84
                        }
                    }
                    totalCount
                }
            }
            totalCount
        }
    }
`;
